import { NavLink } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { SportIcon } from "@/components/SportIcon";

const linkCls = ({ isActive }) =>
  `group flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors ${
    isActive ? "bg-[#10B981]/10 text-[#10B981]" : "text-slate-300 hover:bg-[#1A2234] hover:text-white"
  }`;

export const SportsSidebar = ({ onNavigate }) => {
  const { data } = useQuery({ queryKey: ["sports"], queryFn: () => api.get("/sports").then((r) => r.data), refetchInterval: 60000 });
  const live = (data || []).reduce((a, s) => a + s.live, 0);
  return (
    <nav data-testid="sports-sidebar" className="space-y-1 p-3">
      <NavLink to="/live" className={linkCls} onClick={onNavigate} data-testid="sidebar-link-live">
        <SportIcon sport="live" />
        <span className="flex-1 font-semibold">Live In-Play</span>
        <span className="rounded bg-[#EF4444]/15 px-1.5 py-0.5 text-[10px] font-bold text-[#EF4444]">{live}</span>
      </NavLink>
      <div className="px-3 pb-1 pt-4 text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">Games</div>
      {[["/racing", "horse-racing", "Horse Racing"], ["/lotto", "lotto", "Lotto · Lucky Numbers"], ["/fly-high", "crash", "Fly High"]].map(([to, ic, label]) => (
        <NavLink key={to} to={to} className={linkCls} onClick={onNavigate} data-testid={`sidebar-link-${ic}`}>
          <SportIcon sport={ic} /> <span className="flex-1">{label}</span>
          <span className="rounded bg-[#F59E0B]/15 px-1.5 text-[9px] font-bold uppercase text-[#F59E0B]">Hot</span>
        </NavLink>
      ))}
      <div className="px-3 pb-1 pt-4 text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">Sports A–Z</div>
      {(data || []).map((s) => (
        <NavLink key={s.key} to={`/sport/${s.key}`} className={linkCls} onClick={onNavigate} data-testid={`sidebar-link-${s.key}`}>
          <SportIcon sport={s.key} />
          <span className="flex-1">{s.name}</span>
          {s.live > 0 && <span className="live-dot h-1.5 w-1.5 rounded-full bg-[#EF4444]" />}
          <span className="text-[11px] text-slate-500">{s.upcoming + s.live}</span>
        </NavLink>
      ))}
      <div className="px-3 pb-1 pt-4 text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">More</div>
      <NavLink to="/results" className={linkCls} onClick={onNavigate} data-testid="sidebar-link-results">
        <SportIcon sport="baseball" /> <span>Results</span>
      </NavLink>
    </nav>
  );
};
